import mixpanel from "mixpanel-browser";
import { MIXPANEL_TOKEN_VERSION } from "../constants";

const MIXPANEL_TOKEN =
  MIXPANEL_TOKEN_VERSION === "dev"
    ? process.env.REACT_APP_MIXPANEL_DEV_TOKEN
    : process.env.REACT_APP_MIXPANEL_PROD_TOKEN;

const MIXPANEL_ENABLED = Boolean(MIXPANEL_TOKEN);

if (MIXPANEL_ENABLED) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: false,
    track_pageview: false,
  });
}

export default mixpanel;

export const setSuperProperties = (properties) => {
  if (!MIXPANEL_ENABLED) return;
  mixpanel.register(properties);
};

export const trackEvent = (eventName, properties = {}) => {
  if (!MIXPANEL_ENABLED) return;
  mixpanel.track(eventName, properties);
};

export const identifyUser = (userId) => {
  if (!MIXPANEL_ENABLED) return;
  mixpanel.identify(userId);
};

export const setUserProfile = (userData) => {
  if (!MIXPANEL_ENABLED) return;
  mixpanel.people.set(userData);
};
